import { StyleSheet } from "@react-pdf/renderer";

const styles = StyleSheet.create({
  page: {
    backgroundColor: "#FFFFFF",
    paddingRight: "20px",
    paddingLeft: "50px",
    paddingTop: "10px",
    fontFamily: "Roboto",
  },

  textContent: {
    lineHeight: 1.2,
  },

  checkboxWrapper: {
    position: "relative",
    paddingLeft: "20pt",
    paddingRight: "5pt",
  },

  checkbox: {
    border: "1pt solid #000000",
    width: "10pt",
    height: "10pt",
    position: "absolute",
    top: "2pt",
    borderRadius: 100,
    fontSize: 8,
  },

  checkboxChecked: {
    border: "1pt solid #000000",
    width: "10pt",
    height: "10pt",
    backgroundColor: "#555555",
    position: "absolute",
    top: "2pt",
    borderRadius: 100,
  },

    smallCheckboxChecked: {
    border: "1pt solid #000000",
    width: "5pt",
    height: "5pt",
    position: "absolute",
    top: "2pt",
    borderRadius: 0,
    fontSize: 8,
    backgroundColor: "#000"
  },
});

export default styles;
